/* SK-theme: mobiele menu-drawer die onder de header openklapt met drill-down navigatie. */
class SkMenuDrawer extends HTMLElement {
  connectedCallback() {
    this.toggleBtn = this.querySelector('.sk-menu__toggle');
    this.drawer = this.querySelector('.sk-menu__drawer');
    this.viewport = this.querySelector('.sk-menu__viewport');
    if (!this.toggleBtn || !this.drawer) return;

    this.panels = [...this.querySelectorAll('.sk-menu__panel')];
    this.stack = ['root'];

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.position = this.position.bind(this);

    this.toggleBtn.addEventListener('click', () => {
      if (this.classList.contains('is-open')) this.close();
      else this.open();
    });

    // drill-down: open een subpaneel
    this.querySelectorAll('[data-open]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.goTo(btn.getAttribute('data-open'));
      });
    });

    // terug naar vorige paneel
    this.querySelectorAll('[data-back]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.back();
      });
    });
  }

  panelById(id) {
    return this.panels.find((p) => p.dataset.panel === id);
  }

  goTo(id) {
    const current = this.panelById(this.stack[this.stack.length - 1]);
    const next = this.panelById(id);
    if (!next) return;
    if (current) current.classList.add('is-prev');
    if (current) current.classList.remove('is-active');
    next.classList.remove('is-prev');
    next.classList.add('is-active');
    next.scrollTop = 0;
    this.stack.push(id);
    const focusable = next.querySelector('.sk-menu__back, .sk-menu__entry');
    if (focusable) focusable.focus({ preventScroll: true });
  }

  back() {
    if (this.stack.length < 2) return;
    const current = this.panelById(this.stack.pop());
    const prev = this.panelById(this.stack[this.stack.length - 1]);
    if (current) current.classList.remove('is-active');
    if (prev) {
      prev.classList.remove('is-prev');
      prev.classList.add('is-active');
    }
  }

  reset() {
    this.panels.forEach((p) => {
      p.classList.remove('is-prev');
      p.classList.toggle('is-active', p.dataset.panel === 'root');
    });
    this.stack = ['root'];
  }

  position() {
    const main = document.querySelector('.sk-header__main');
    const top = main ? Math.max(0, Math.round(main.getBoundingClientRect().bottom)) : 0;
    this.drawer.style.setProperty('--sk-menu-top', top + 'px');
  }

  open() {
    this.reset();
    this.position();
    this.classList.add('is-open');
    this.toggleBtn.setAttribute('aria-expanded', 'true');
    this.drawer.hidden = false;
    void this.drawer.offsetWidth;
    this.classList.add('is-visible');
    document.body.classList.add('sk-menu-open');
    document.addEventListener('keydown', this.onKeydown);
    window.addEventListener('resize', this.position);
  }

  close() {
    this.classList.remove('is-visible');
    this.toggleBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('sk-menu-open');
    document.removeEventListener('keydown', this.onKeydown);
    window.removeEventListener('resize', this.position);
    const drawer = this.drawer;
    const self = this;
    const onEnd = () => {
      self.classList.remove('is-open');
      drawer.hidden = true;
      drawer.removeEventListener('transitionend', onEnd);
    };
    drawer.addEventListener('transitionend', onEnd);
    setTimeout(onEnd, 400);
  }

  onKeydown(e) {
    if (e.key === 'Escape') this.close();
  }
}

if (!customElements.get('sk-menu-drawer')) {
  customElements.define('sk-menu-drawer', SkMenuDrawer);
}
